import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { userHasPermission } from 'utils/permissions';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();
  const { opened } = useSelector((state) => state.customization);
  const userData = useSelector((state) => state.user.data);

  // menu list collapse & items
  const items = item.children
    ?.filter((child) => {
      const isAuthorized = userHasPermission({
        userData,
        validPermissionsAdmin: child.minimumPermissions,
        validPermissionsManager: child.minimumPermissions
      });
      return isAuthorized;
    })
    .map((menu) => {
      switch (menu.type) {
        case 'collapse':
          return <NavCollapse key={menu.id} menu={menu} level={1} />;
        case 'item':
          return <NavItem key={menu.id} item={menu} level={1} />;
        default:
          return (
            <Typography key={menu.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
      }
    });

  return (
    <>
      <List
        subheader={
          item.title && opened ? (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption, textWrap: 'nowrap' }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption, textWrap: 'nowrap' }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          ) : (
            ''
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
